const copyText = (elementId) => {
  const element = document.getElementById(elementId);
  if (element && navigator.clipboard) {
    if (element.tagName.toLowerCase() === 'input') {
      navigator.clipboard.writeText(element.value);
    } else {
      navigator.clipboard.writeText(element.textContent);
    }
  }
};

export default copyText;
